(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 57354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4z"
}), 'ArrowRightAlt');

exports.Z = _default;

/***/ }),

/***/ 326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');

exports.Z = _default;

/***/ }),

/***/ 67801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(1391);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _meta_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53183);



var PageMetaHead = function(param) {
    var page_meta = param.page_meta, useExactTitle = param.useExactTitle;
    if (!page_meta) return null;
    var title = page_meta.title ? "".concat(_meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC, " - ").concat(page_meta.title) : _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC;
    if (useExactTitle) {
        title = page_meta.title ? page_meta.title : _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            page_meta.keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_META_KEYWORDS */ .FK
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: title
            }, "og:site_name"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }, "twitter:title"),
            page_meta.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: page_meta.description
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: page_meta.description
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: page_meta.description
                    }, "twitter:description")
                ]
            }),
            page_meta.thumbnail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: page_meta.thumbnail
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: page_meta.thumbnail
                    }, "og:image:secure_url"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: page_meta.thumbnail
                    }, "twitter:image")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMetaHead);


/***/ }),

/***/ 3022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getAllBlogPosts; }
/* harmony export */ });
/* unused harmony export getBlogPost */
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13223);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);


var getAllBlogPosts = function() {
    var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, per_page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    return axios__WEBPACK_IMPORTED_MODULE_1___default().get("/blogs", {
        params: {
            page: page,
            per_page: per_page
        },
        baseURL: _config__WEBPACK_IMPORTED_MODULE_0__/* .httpConfig.baseURL */ .is.baseURL,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });
};
var getBlogPost = function(slug) {
    return axios.get("/blogs/get-blog-by-slug/".concat(slug), {
        baseURL: httpConfig.baseURL,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });
};


/***/ }),

/***/ 1391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(79072);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_logic_config_meta_PageMetaHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51199);
/* harmony import */ var src_logic_hooks_use_scroll_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20042);
/* harmony import */ var src_logic_services_blog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3022);
/* harmony import */ var src_ui_components_smart_catalogue_catalogue_content_components_EmptySection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74887);
/* harmony import */ var src_ui_components_smart_catalogue_catalogue_content_components_ErrorSection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70833);
/* harmony import */ var src_ui_components_smart_catalogue_catalogue_content_components_LoadingSection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17641);
/* harmony import */ var src_ui_components_smart_landing_blog_BlogPostCard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87333);
/* harmony import */ var src_ui_components_smart_landing_layout_LandingLayout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28140);














var PER_PAGE = 12;
var BlogPage = function(param) {
    var initialData = param.initialData;
    var ref;
    var ref1 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__.useInfiniteQuery)({
        queryKey: [
            "BLOG_POSTS"
        ],
        queryFn: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
                var _pageParam, pageParam, data;
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? initialData ? 2 : 1 : _pageParam;
                            _ctx.next = 3;
                            return (0,src_logic_services_blog__WEBPACK_IMPORTED_MODULE_5__/* .getAllBlogPosts */ .S)(pageParam, PER_PAGE);
                        case 3:
                            data = _ctx.sent.data;
                            return _ctx.abrupt("return", data.data);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        getNextPageParam: function(lastPage) {
            var ref = lastPage === null || lastPage === void 0 ? void 0 : lastPage.meta, current_page = ref.current_page, last_page = ref.last_page;
            return current_page < last_page ? current_page + 1 : undefined;
        },
        initialData: initialData ? {
            pageParams: [
                1
            ],
            pages: [
                initialData
            ]
        } : undefined,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: 1
    }), data = ref1.data, isLoading = ref1.isLoading, isError = ref1.isError, refetch = ref1.refetch, hasNextPage = ref1.hasNextPage, fetchNextPage = ref1.fetchNextPage, isFetchingNextPage = ref1.isFetchingNextPage;
    var ref2, ref3;
    var posts = (ref3 = data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap(function(page) {
        return (ref2 = page === null || page === void 0 ? void 0 : page.data) !== null && ref2 !== void 0 ? ref2 : [];
    })) !== null && ref3 !== void 0 ? ref3 : [];
    var isEmpty = posts.length === 0;
    var ref4 = (0,src_logic_hooks_use_scroll_observer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        onIntersect: function() {
            if (hasNextPage && !isFetchingNextPage) {
                fetchNextPage === null || fetchNextPage === void 0 ? void 0 : fetchNextPage();
            }
        }
    }), observerRef = ref4.observerRef, containerRef = ref4.containerRef;
    if (isLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_ui_components_smart_catalogue_catalogue_content_components_LoadingSection__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            label: "Loading Posts...",
            minHeight: "85vh"
        });
    }
    if (isError) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_ui_components_smart_catalogue_catalogue_content_components_ErrorSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            refetch: refetch,
            minHeight: "85vh"
        });
    }
    if (isEmpty) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_ui_components_smart_catalogue_catalogue_content_components_EmptySection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            hideQuestion: true,
            text: "No posts found",
            minHeight: "85vh"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "page",
        ref: containerRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "page__content",
            style: {
                paddingBlock: "4em"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    color: "#3A3E50",
                    fontWeight: 600,
                    fontSize: {
                        xs: 26,
                        lg: 44
                    },
                    textAlign: "center",
                    mb: 4,
                    mx: "auto",
                    maxWidth: "15ch",
                    lineHeight: 1,
                    component: "h1",
                    children: [
                        "Stay Updated With ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            style: {
                                color: "#005FCC"
                            },
                            children: "Our Latest Posts"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                    container: true,
                    spacing: 2,
                    children: posts.map(function(post) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 4,
                            xl: 4,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_ui_components_smart_landing_blog_BlogPostCard__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                post: post
                            })
                        }, "".concat(post.id, "-").concat(post.slug));
                    })
                }),
                hasNextPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        marginBlock: "2rem",
                        opacity: isFetchingNextPage ? 1 : 0,
                        transition: "opacity 200ms"
                    },
                    ref: observerRef,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_ui_components_smart_catalogue_catalogue_content_components_LoadingSection__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        minHeight: "auto",
                        label: "Loading More...",
                        loadingIndicatorSize: "1rem"
                    })
                })
            ]
        })
    });
};
BlogPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_ui_components_smart_landing_layout_LandingLayout__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_logic_config_meta_PageMetaHead__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                page_meta: {
                    title: "AI-Powered Procurement Solutions for Modern Businesses",
                    description: "Streamline your procurement process with AI-driven solutions, Automate tendering, sourcing, contract approvals, and supplier management using smart SaaS software."
                }
            }),
            page
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogPage);


/***/ }),

/***/ 74887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29630);
/* harmony import */ var src_logic_hooks_auth_use_is_user_pending_approval__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92270);
/* harmony import */ var src_logic_hooks_smart_catalogue_use_can_modify_catalogue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91394);
/* harmony import */ var _shared_Add_private_item_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68480);





var EmptySection = function(param) {
    var _text = param.text, text = _text === void 0 ? "No Results Found" : _text, children = param.children, hideQuestion = param.hideQuestion, _minHeight = param.minHeight, minHeight = _minHeight === void 0 ? "175px" : _minHeight;
    var isUserPendingApproval = (0,src_logic_hooks_auth_use_is_user_pending_approval__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var canModifyCatalogue = (0,src_logic_hooks_smart_catalogue_use_can_modify_catalogue__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() && !isUserPendingApproval;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "1rem",
            minHeight: minHeight
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/assets/images/no-results.png",
                alt: "Empty",
                width: 80,
                height: 80,
                style: {
                    objectFit: "contain"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                color: "#3A3E50",
                fontWeight: 700,
                fontSize: 21,
                textAlign: "center",
                children: text
            }),
            !hideQuestion && (children || canModifyCatalogue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_Add_private_item_link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmptySection);


/***/ }),

/***/ 68480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13223);
/* harmony import */ var _zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14398);
/* harmony import */ var _mui_icons_material_InfoOutlined__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2548);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17575);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54225);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var src_site_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29951);









var AddNewPrivateItemLink = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var isPurchaseOrderEnvironment = (0,_zustand__WEBPACK_IMPORTED_MODULE_2__/* .useProcurementStore */ .fp)(function(state) {
        var ref, ref1;
        var env = (ref = state.productFormManagerProperties.data) === null || ref === void 0 ? void 0 : (ref1 = ref.environment) === null || ref1 === void 0 ? void 0 : ref1.type;
        return env === _config__WEBPACK_IMPORTED_MODULE_1__/* .ProductManagerEnv.purchase_order */ .Hb.purchase_order || env === _config__WEBPACK_IMPORTED_MODULE_1__/* .ProductManagerEnv.edit_po_from_scratch */ .Hb.edit_po_from_scratch;
    });
    var isDisabled = isPurchaseOrderEnvironment;
    var link = react__WEBPACK_IMPORTED_MODULE_5__.useMemo(function() {
        var queryString = new URLSearchParams(props).toString();
        return queryString ? "".concat(src_site_map__WEBPACK_IMPORTED_MODULE_6__.sm.catalogue.products.add.url, "?").concat(queryString) : src_site_map__WEBPACK_IMPORTED_MODULE_6__.sm.catalogue.products.add.url;
    }, [
        props
    ]);
    var isAddProductPage = router.pathname === "/catalogue/products/add";
    if (isAddProductPage) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        lineHeight: 1,
        variant: "subtitle2",
        fontWeight: 500,
        color: "text.third",
        children: [
            "Can\u2019t find your product / service?",
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                title: isDisabled ? "You cannot add new products in PO environment." : "",
                disableHoverListener: !isDisabled,
                arrow: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        sx: {
                            fontWeight: 700
                        },
                        startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_InfoOutlined__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            sx: {
                                fontSize: "sm",
                                color: "primary.main",
                                mr: -0.5,
                                opacity: isDisabled ? 0.5 : 1
                            }
                        }),
                        disabled: isDisabled,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                lineHeight: 1,
                                fontWeight: 700,
                                fontSize: "12px",
                                color: "primary",
                                sx: {
                                    opacity: isDisabled ? 0.5 : 1
                                },
                                children: "Add New"
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AddNewPrivateItemLink);


/***/ }),

/***/ 87333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_ArrowRightAlt__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57354);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93789);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54225);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_site_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29951);






var BlogPostCard = function(param) {
    var post = param.post;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        sx: {
            backgroundColor: "#fff",
            borderRadius: "20px",
            boxShadow: "0px 0px 40px 0px #0017721A",
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(post.cover_photo_path, "?v=").concat(post.id),
                        alt: post.photo_alt_text,
                        style: {
                            display: "block",
                            borderRadius: "10px",
                            objectFit: "cover",
                            objectPosition: "center",
                            width: "100%",
                            height: "175px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        fontSize: {
                            xs: 8,
                            lg: 11
                        },
                        fontWeight: 700,
                        textTransform: "uppercase",
                        color: "#fff",
                        sx: {
                            backgroundColor: "#0F5D85",
                            borderRadius: "30px",
                            display: "inline-block",
                            py: 1,
                            px: 2,
                            letterSpacing: "2px",
                            my: 2
                        },
                        children: moment__WEBPACK_IMPORTED_MODULE_1___default()(post.published_at, "DD-MM-YYYY").format("ll")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        color: "#070A0D",
                        fontWeight: 600,
                        fontSize: {
                            xs: 16,
                            lg: 20
                        },
                        lineHeight: 1.25,
                        component: "h3",
                        sx: {
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                            overflow: "hidden"
                        },
                        children: post.title
                    }),
                    post.sub_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        color: "#1D2935",
                        fontWeight: 400,
                        fontSize: {
                            xs: 12,
                            lg: 16
                        },
                        lineHeight: 1.25,
                        mt: 1,
                        sx: {
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                            overflow: "hidden"
                        },
                        children: post.sub_title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "end",
                mt: 2,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: src_site_map__WEBPACK_IMPORTED_MODULE_3__.sm.blog.post(post.slug).url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        type: "button",
                        endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowRightAlt__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                        sx: {
                            color: "#0F5D85",
                            fontWeight: 600
                        },
                        children: "Read This Article"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogPostCard);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8140,9774,2888,179], function() { return __webpack_exec__(67801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);